import React from "react";
import "../css/SessionExpiredPopup.css";
import { useLogout } from "../../services/LogoutProvider";
import { Modal } from "@mui/material";

const SessionExpiredPopup = () => {
  const { isSessionExpired, handleSessionExpiredConfirm } = useLogout();

  return (
    <Modal
      className="session-expired-popup"
      open={isSessionExpired}
      onOk={handleSessionExpiredConfirm}
    >
      <div className="session-expired-popup-content">
        <h2>Session Expired</h2>
        <p>Your session has expired. Please log in again.</p>
        <button onClick={handleSessionExpiredConfirm}>Okay</button>
      </div>
    </Modal>
  );
};

export default SessionExpiredPopup;
